/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Joi = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _vogelsPolyfill = require('./vogelsPolyfill');

var _vogelsPolyfill2 = _interopRequireDefault(_vogelsPolyfill);

var _uriRegexp = require('./uriRegexp');

var _uriRegexp2 = _interopRequireDefault(_uriRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Abstraction on Joi validation expressions
 */
let Joi = exports.Joi = function () {
  function Joi() {
    _classCallCheck(this, Joi);
  }

  _createClass(Joi, null, [{
    key: 'uuid',

    /**
     * @returns {Object}
     */
    get: function get() {
      return _vogelsPolyfill2.default.types.uuid();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'timeUUID',
    get: function get() {
      return _vogelsPolyfill2.default.types.timeUUID();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'stringSet',
    get: function get() {
      return _vogelsPolyfill2.default.types.stringSet();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'numberSet',
    get: function get() {
      return _vogelsPolyfill2.default.types.numberSet();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'binarySet',
    get: function get() {
      return _vogelsPolyfill2.default.types.binarySet();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'binary',
    get: function get() {
      return _joi2.default.binary();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'number',
    get: function get() {
      return _joi2.default.number();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'string',
    get: function get() {
      return _joi2.default.string();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'boolean',
    get: function get() {
      return _joi2.default.boolean();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'email',
    get: function get() {
      return _joi2.default.string().email();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'website',
    get: function get() {
      let strJoiObj = _joi2.default.string();

      // Fix for Joi v5.x.x
      return strJoiObj.hasOwnProperty('uri') ? strJoiObj.uri() : strJoiObj.regex(_uriRegexp2.default.createUriRegex());
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'map',
    get: function get() {
      return _joi2.default.object();
    }

    /**
     * @returns {*}
     */

  }, {
    key: 'mapSet',
    get: function get() {
      let array = _joi2.default.array();
      if (array.includes) {
        return array.includes(_joi2.default.object());
      }

      return array.items(_joi2.default.object());
    }
  }]);

  return Joi;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Helpers/Joi.js
// module id = 460
// module chunks = 0